import initialState from './../../initialState';
import { Step } from './constants';

export default (
  state = initialState.guiaInterativo,
  { type, value, isNew }
) => {
  switch (type) {
    case 'CHECKIN_PRESENCA_CONTRATADO_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        stepIndex: Step.CADASTRO_CONTRATADO_INCLUSAO
      };
    case 'CREATE_RESERVAS_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        stepIndex: isNew
          ? Step.CADASTRO_RESERVA_AGENDADA
          : Step.CADASTRO_RESERVA_REAGENDADA
      };
    case 'APROVA_RESERVAS_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        stepIndex: Step.CADASTRO_RESERVA_APROVADA
      };
    case 'CANCELA_RESERVAS_SUCCESS_GUIA_INTERATIVO':
      return {
        ...state,
        stepIndex: Step.CADASTRO_RESERVA_CANCELADA
      };
    case 'USER_ROLES_SUCCESS':
      return {
        ...state,
        //                run: !localStorage.getItem("guiaInterativo"),
        run: false
      };
    case 'ABRIR_GUIA_INTERATIVO':
      return {
        ...state,
        stepIndex: value,
        run: true
      };
    case 'ENCERRAR_GUIA_INTERATIVO':
      return {
        ...state,
        stepIndex: 0,
        run: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/guiaInterativo/reducer.js